import { render, staticRenderFns } from "./ForumThreadPageResponseList.vue?vue&type=template&id=70f76616&scoped=true"
import script from "./ForumThreadPageResponseList.vue?vue&type=script&lang=js"
export * from "./ForumThreadPageResponseList.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadPageResponseList.vue?vue&type=style&index=0&id=70f76616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f76616",
  null
  
)

export default component.exports